import Button from "./Button"
import Form from "./Form"
import { useState, useRef, useEffect } from 'react'
import { v4 as uuidv4} from 'uuid'
import Drink from "./Drink"


const AddRecipe = () => {

    const drinkName = useRef();
    const ingredients = useRef();
    const process = useRef();
    const creator = useRef();
    const LOCAL_STORAGE_KEY = 'drinkApp';
    const [drinks, setDrinks] = useState([]);
    const id = uuidv4();

    useEffect(() => {
        const storedDrink = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEY));
        if (storedDrink) {
            setDrinks(storedDrink);
        }
    }, [])

    useEffect(() => {
        localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(drinks));
    }, [drinks])

    const [showForm, setShowForm] = useState(false);
    const formShown = () => {
        setShowForm (!showForm)
    }

    const handleNewDrink = (e) => {
        e.preventDefault();
        let firstInput = drinkName.current.value;
        let secondInput = ingredients.current.value;
        let thirdInput = process.current.value;
        let fourthInput = creator.current.value;
        setDrinks(prevDrink => {
            return[...prevDrink, {id: id, firstInput, secondInput, thirdInput, fourthInput}]
        })
        drinkName.current.value = '';
        ingredients.current.value = '';
        process.current.value = '';
        creator.current.value = '';
    }

    const deleteRecipe = (id) => {
        setDrinks(drinks.filter((drink)=> drink.id !== id))
    }


    return (
            
            <div className="mb-auto grid place-items-center bg-white/75">
                <h2 className="text-3xl m-3">Do you want to share a recipe?</h2>
                <Button btnName={'Share a drink'} onClick={formShown} />
                {showForm ? 
                <Form handleNewDrink={handleNewDrink} 
                drinkName={drinkName} ingredients={ingredients} process={process} creator={creator} /> : null}

                <div className='border-2 border-black text-center w-2/3'>
                    <h3 className="text-2xl m-2 underline">Our users shared recipe:</h3>
                    {drinks.map((drink) => (
                        <Drink key={drink.id} drink={drink} onDelete={deleteRecipe} />
                    ))}


                </div>
            </div>

    )
}

export default AddRecipe